import {forwardRef, useImperativeHandle, useState, useRef, useEffect} from 'react';

export default forwardRef((props, ref) => {
  const [value, setValue] = useState('');
  const textInput = useRef();

  let input_class = props.custom_class ? props.custom_class : 'text-filter-default';

  let placeholder_text = 'Filter';

  // legacy code for using the column name as the placeholder,
  // removed at client request but we might want it back someday
  // if (props.column.colDef.headerName) {
  //   placeholder_text = `Filter by ${props.column.colDef.headerName}`;
  // } else {
  //   placeholder_text = 'Filter by name';
  // }

  const updateInput = (value) => {
    textInput.current.value = value;
  };

  useImperativeHandle(ref, () => {
    return {
      onParentModelChanged(parentModel) {
        if (parentModel) {
          setValue(parentModel.state);
          updateInput(parentModel.state);
        } else {
          setValue('');
          updateInput('');
        }
      },
    };
  });

  const onFloatingFilterChange = (input) => {
    setValue(input);
    props.parentFilterInstance((instance) => {
      instance.setValue(input);
    });
  };

  return (
    <div className="ag-input-wrapper">
      <input
        className={`${input_class} ${props.column.colDef.field}-floating-filter`}
        type="text"
        placeholder={placeholder_text}
        ref={textInput}
        onChange={(e) => onFloatingFilterChange(e.target.value)}
      />
    </div>
  );
});
